import { atomWithStorage } from "jotai/utils";

export interface UserProfile {
	DateBirth: string;
	Email: string;
    FirstName: string
    Gender: string
	LastName: string
    MembershipNo: string
    MembershipType: string
    MiddleName: string
    Name: string
    PhoneNumber: string
    ResidentialAddress: string
    UploadPictureUrl: string
    WhatsAppNumber: string
    StateId: number
    StateOriginId: number
    LicenseExpire: string
CreatedDate: string
}

export const tokenAtom = atomWithStorage("e-voting-member-token", "");

export const userAtom = atomWithStorage("e-voting-member-user",
//  {
//   Token: '',
//   MemberId: '',
//   Expiration: '',
//   AccountType: null,
//   Role: null || [],
//   IsNewApplicant: false,
//   MembershipTypeId: 0,
//   ApplicantId: ''
// }, 
JSON.parse(localStorage.getItem("e-voting-member-user")!) ?? undefined);

export const profileDetails = atomWithStorage<UserProfile | undefined>("e-voting-profile-details",JSON.parse(localStorage.getItem("e-voting-profile-details")!) ?? undefined);


